import { observer } from 'mobx-react-lite'
import { type MessageFieldStore } from 'widgets/MessageField'
import { AutoContentAction } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/AutoContentAction/AutoContentAction'
import type { AutoControlStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/autoControlStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IActionsStep3SMSProps = {
  control: AutoControlStore
  contentStore: MessageFieldStore
}

export const ActionsStep3SMS = observer(({ control, contentStore }: IActionsStep3SMSProps) => (
  <div className={styles.actionStep}>
    <AutoContentAction
      title={'Let AI write this message'}
      questionInfoTooltip='Agent will write this message based on the conversation'
      control={control}
      contentStore={contentStore}
    />
  </div>
))
